import { Box, Drawer, Switch, Typography } from "@mui/material"
import React, { Dispatch, SetStateAction } from "react"
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"
import { IconFilter } from "../custom-icons/icon-filter"

interface IProps {
  openDrawerFilter: boolean
  fetchOnlyMyData: boolean
  setFetchOnlyMyData: Dispatch<SetStateAction<boolean>>

  setOpenDrawerFilter(isOpen: boolean): void
}

export function FilterListDrawer({
  openDrawerFilter,
  fetchOnlyMyData,
  setFetchOnlyMyData,
  setOpenDrawerFilter,
}: Readonly<IProps>): React.JSX.Element {
  return (
    <Drawer
      open={openDrawerFilter}
      onClose={() => setOpenDrawerFilter(false)}
      anchor="right"
      PaperProps={{
        style: {
          backgroundColor: "#F5F8F8",
        },
      }}>
      <Box width="55vh">
        <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center" p={2}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <Box
              display="flex"
              alignItems="center"
              sx={{ borderRadius: 2, background: "#b7ffe3", p: 1, border: 3, borderColor: "white" }}>
              <IconFilter />
            </Box>

            <Typography variant="h6"> Filtrer</Typography>
          </Box>
          <ArrowForwardIcon onClick={() => setOpenDrawerFilter(false)} sx={{ cursor: "pointer" }} />
        </Box>
        <Box m={3} p={1} boxShadow="2px 4px 20px 0px rgba(0, 0, 0, 0.05)" borderRadius={3} sx={{ background: "white" }}>
          <Box display="flex" justifyContent="center" alignItems="center" gap={2}>
            <Switch
              checked={fetchOnlyMyData}
              onChange={() => setFetchOnlyMyData(!fetchOnlyMyData)}
              inputProps={{ "aria-label": "controlled" }}
              sx={{ marginLeft: "-10px" }}
            />
            <Typography variant="body2">Voir uniquement mes projets</Typography>
          </Box>
        </Box>
      </Box>
    </Drawer>
  )
}
